import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import { Router } from '@angular/router';
import { AdminService } from './admin';
@Injectable()
export class AuthGard implements CanActivate{

	private isConnected: boolean=false;
	constructor(private adminService : AdminService,public router: Router){

	}
	canActivate(){
		console.log('Call authentification guard');
		if(this.adminService.getLoginUseCMS())return true;
		console.log('orientation vers login');
		this.router.navigate(['/login']);
		return false;
	}
}